import React from "react";
import styles from "./_WorkflowFilterBar.less";
import WorkflowFilterBarModulo from "./_WorkflowFilterBarModulo";
import WorkflowFilterBarEmpresa from "./_WorkflowFilterBarEmpresa";
import WorkflowFilterBarAcesso from "./_WorkflowFilterBarAcesso";
import WorkflowFilterBarMembro from "./_WorkflowFilterBarMembro";
import WorkflowFilterBarUnidade from "./_WorkflowFilterBarUnidade";
import { FilterOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import WorkflowFilterBarTipo from "./_WorkflowFilterBarTipo";
import WorkflowFilterBarAno from "./_WorkflowFilterBarAno";
import { useSelector } from "react-redux";
import { workflowSelector } from "../../store/workflow";

export default function WorkflowFilterBar() {
  const { t } = useTranslation();
  const workflow = useSelector(workflowSelector);
  return (
    <div className={styles["workflow-filter-bar"]}>
      <div className={styles["membro"]}>
        <div className={styles["icone"]}>
          <div>
            <FilterOutlined />
          </div>
          <div>{t("Membro")}</div>
        </div>
        <WorkflowFilterBarMembro />
      </div>
      <div className={styles["modulo"]}>
        <div className={styles["icone"]}>
          <div>
            <FilterOutlined />
          </div>
          <div>{t("Módulo")}</div>
        </div>
        <WorkflowFilterBarModulo />
      </div>
      <div className={styles["acesso"]}>
        <div className={styles["icone"]}>
          <div>
            <FilterOutlined />
          </div>
          <div>{t("Acesso")}</div>
        </div>
        <WorkflowFilterBarAcesso />
      </div>
      <div className={styles["empresa"]}>
        <div className={styles["icone"]}>
          <div>
            <FilterOutlined />
          </div>
          <div>{t("Empresa")}</div>
        </div>
        <WorkflowFilterBarEmpresa />
      </div>
      <div className={styles["unidade"]}>
        <div className={styles["icone"]}>
          <div>
            <FilterOutlined />
          </div>
          <div>{t("Unidade")}</div>
        </div>
        <WorkflowFilterBarUnidade />
      </div>
      <div className={styles["tipo"]}>
        <div className={styles["icone"]}>
          <div>
            <FilterOutlined />
          </div>
          <div>{t("Tipo Tarefa")}</div>
        </div>
        <WorkflowFilterBarTipo />
      </div>
      {workflow.arquivado && (
        <div className={styles["tipo"]}>
          <div className={styles["icone"]}>
            <div>
              <FilterOutlined />
            </div>
            <div>{t("Ano")}</div>
          </div>
          <WorkflowFilterBarAno />
        </div>
      )}
    </div>
  );
}
